import url from 'url';
import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Button, Base } from '@gandi/ui';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "heading": "SaveCreditCard-heading_DBCIB"
};
export default function SaveCreditCard(props) {
  const {
    adminURL,
    sharingId
  } = props;
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsxs(Base, {
    backgroundColor: "surface",
    marginBottom: "small",
    tagName: "section",
    flex: true,
    flexCol: true,
    paddingX: "small",
    borderRadius: "1x",
    children: [/*#__PURE__*/_jsxs(Base, {
      className: styles.heading,
      flex: true,
      flexColToRow: true,
      flexJustifyBetween: true,
      paddingY: "small",
      gap: "xsmall",
      children: [/*#__PURE__*/_jsxs(Base, {
        size: "bigger",
        weight: "semibold",
        flexGrow1: true,
        children: [__('Save your credit card for next purchases!'), ' ']
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Button, {
          small: true,
          iconAfter: "arrowRight",
          kind: "outline",
          href: url.resolve(adminURL, `/billing/${sharingId}/payment-methods/add`),
          children: __('Save a credit card')
        })
      })]
    }), /*#__PURE__*/_jsx(Base, {
      marginBottom: "small",
      children: /*#__PURE__*/_jsx("span", {
        children: __('By saving a credit card for your organization, you will be able to speed up your ' + 'purchases and automatic renewals. Your credit card or other payment account ' + 'information will be safely stored at our payment gateway and you can delete or ' + 'modify them at any time.')
      })
    })]
  });
}